import React, { Component } from 'react';

import classes from './Dropdown.css';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';

class Dropdown extends Component {

  constructor (props){
    super(props);

    this.state = {
        showMenu: false
      };

    this.displayMenu = this.displayMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  displayMenu(ev) {
    ev.preventDefault();
    this.setState({ showMenu: true }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }

  closeMenu(ev) {
    if (!this.dropdownMenu.contains(ev.target)) {
      this.setState({ showMenu: false }, () => {
        document.removeEventListener('click', this.closeMenu);
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeMenu);
  }

  render() {
    let menuClasses = [classes.Menu];
    if (this.state.showMenu) {
      menuClasses.push(classes.Visible);
    }

    let icon = null;
    if (this.props.dropIcon) {
      icon = <Icon iconSource={this.props.dropIcon} iconAlt="" className={this.props.dropIconClass} />
    }

    let dropdownClass = classes.Dropdown;
    if (this.props.className) {
      dropdownClass = this.props.className;
    }

    return (
      <div className={dropdownClass}>
        <button
          onClick={this.displayMenu}
          className={[classes.DropdownButton, this.props.extraClass ? this.props.extraClass : null].join(' ')}>
          {icon}{this.props.dropdown}
        </button>
        <div
          className={menuClasses.join(' ')}
          ref={(el) => { this.dropdownMenu = el; }}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/UI/Dropdown/Dropdown.js